import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMTipoAtividade } from 'src/app/models/crm/crmtipo-atividade';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CrmtipoAtividadeService } from 'src/app/services/crm/crmtipo-atividade.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CRMFiltroAtividade } from 'src/app/models/crm/crmfiltro-atividade';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { GlobalService } from 'src/app/services/global.service';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { Cliente } from 'src/app/models/cliente';

declare const $: any;

@Component({
  selector: 'app-filtro-atividade',
  templateUrl: './filtro-atividade.component.html',
  styleUrls: ['./filtro-atividade.component.scss']
})
export class FiltroAtividadeComponent implements OnInit {
  filtroAtividade: CRMFiltroAtividade;
  pesquisaPeriodo = '';

  tiposDeAtividade: CRMTipoAtividade[] = [];
  usuarios: CRMHierarquiaUsuario[] = [];
  clientes: Cliente[] = [];

  periodos: any[] = [
    { id: 0, nome: 'Todos' },
    { id: 1, nome: 'Hoje' },
    { id: 2, nome: 'Ontem' },
    { id: 3, nome: 'Esta semana' },
    { id: 4, nome: 'Semana passada' },
    { id: 5, nome: 'Este mês' },
    { id: 6, nome: 'Mês passado' },
    { id: 7, nome: 'Personalizado' }
  ];

  status: any[] = [
    { id: -1, nome: 'Todos' },
    { id: 0, nome: 'Em andamento' },
    { id: 1, nome: 'Realizada' },
    { id: 2, nome: 'Excluída' }
  ];

  alertas: any[] = [
    { id: 0, nome: 'Todos', classe: '' },
    { id: 1, nome: 'Verde', classe: 'text-success' },
    { id: 2, nome: 'Laranja', classe: 'text-warning' },
    { id: 3, nome: 'Vermelho', classe: 'text-danger' }
  ];

  statusOportunidade: any[] = [
    { id: -1, nome: 'Todos' },
    { id: 0, nome: 'Aberta' },
    { id: 1, nome: 'Negativo' },
    { id: 2, nome: 'Positivo' }
  ];

  pesoAtividade: any[] = [
    { id: 0, nome: 'Todos' },
    { id: 1, nome: 'Positivamente' },
    { id: -1, nome: 'Negativamente' }
  ]

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FiltroAtividadeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tipoDeAtividadeService: CrmtipoAtividadeService,
    private clienteService: ClienteService
  ) {
    this.filtroAtividade = data.filtro;

    if (data.crm.habilitaGanho && data.crm.habilitaPerda) {
      this.statusOportunidade[2].id = 2;
      this.statusOportunidade[2].nome = data.crm.textoGanho;
      this.statusOportunidade[3].id = 1;
      this.statusOportunidade[3].nome = data.crm.textoPerda;
    } else if (data.crm.habilitaGanho) {
      this.statusOportunidade[2].id = 2;
      this.statusOportunidade[2].nome = data.crm.textoGanho;
      this.statusOportunidade.splice(3, 1);
    } else if (data.crm.habilitaPerda) {
      this.statusOportunidade[3].id = 1;
      this.statusOportunidade[3].nome = data.crm.textoPerda;
      this.statusOportunidade.splice(2, 1);
    }
  }

  ngOnInit() {
    this.buscarTiposDeAtividade();
    this.buscarUsuarios();
    this.buscarClientes();
  }

  buscarTiposDeAtividade() {
    this.carregandoService.mostra('buscaTiposDeAtividade');

    this.tipoDeAtividadeService.consultarTiposAtividade().subscribe(resp => {
      this.tiposDeAtividade = resp;

      const todos = new CRMTipoAtividade();
      todos.id = 0;
      todos.descricao = 'Todos';

      this.tiposDeAtividade.unshift(todos);

      this.carregandoService.esconde('buscaTiposDeAtividade');
    }, (erro) => {
      this.carregandoService.esconde('buscaTiposDeAtividade');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsuarios() {
    this.carregandoService.mostra('buscaUsuarios');

    this.hierarquiaService.consultarHierarquiaDoUsuarioLista().subscribe(resp => {
      this.usuarios = resp;

      const idUser = this.globalService.consultaUsuario();

      this.usuarios.splice(this.usuarios.
        indexOf(this.usuarios.find(p => p.idFuncion === Number(idUser))), 1);

      const todos = new CRMHierarquiaUsuario();
      todos.idFuncion = 0;
      todos.nome = 'Todos';
      this.usuarios.unshift(todos);

      const somenteEu = new CRMHierarquiaUsuario();
      somenteEu.idFuncion = -1;
      somenteEu.nome = 'Somente eu';
      this.usuarios.unshift(somenteEu);

      this.carregandoService.esconde('buscaUsuarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaUsuarios');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarClientes() {
    if (this.filtroAtividade.usuarios.length === 0) {
      return;
    }

    this.carregandoService.mostra('buscarClientes');

    if (this.filtroAtividade.usuarios.length === 1) {
      const usuario = this.filtroAtividade.usuarios[0] === -1 ? 0 : this.filtroAtividade.usuarios[0];

      this.clienteService.consultarClientesDoVendedor(usuario, 1).subscribe(
        (data) => {
          this.clientes = data;
        },
        (erro) => {
          this.notificacaoService.erro('Não foram encontrados Clientes para este usuário.');
        },
        () => {
          this.carregandoService.esconde('buscarClientes');
        }
      );
    } else {
      const requisicoes = this.filtroAtividade.usuarios.map(async (usuario) =>
        await this.clienteService.consultarClientesDoVendedor(usuario, 1).toPromise()
      );

      Promise.all(requisicoes)
        .then((resultados: any[]) => {
          const clientesUnificados: any[] = [];
          resultados.forEach((resultado) => {
            if (Array.isArray(resultado)) {
              clientesUnificados.push(...resultado);
            } else {
              clientesUnificados.push(resultado);
            }
          });
          this.clientes = clientesUnificados;
        })
        .catch((erro) => {
          this.notificacaoService.erro('Ocorreu um erro ao buscar os clientes.');
          console.error('Erro ao buscar clientes: ', erro);
        })
        .finally(() => {
          this.carregandoService.esconde('buscarClientes');
        });
    }
  }

  filtrar() {
    this.dialogRef.close(this.filtroAtividade);
  }

  fechar() {
    this.dialogRef.close();
  }

  adicionouUsuario($event) {
    if ($event.idFuncion == -1) {
      this.filtroAtividade.usuarios = [-1];
    } else if ($event.idFuncion == 0) {
      this.filtroAtividade.usuarios = [0];
    } else {
      this.filtroAtividade.usuarios = this.filtroAtividade.usuarios.filter(p => p !== -1 && p !== 0);
    }
  }
}
